class DeliveryWidget extends HTMLElement {
  constructor() {
    super();
    this.dateFormatOptions = { day: 'numeric', month: 'short' };
    this.deliveryDate = this.querySelector('[data-last="true"]');
    this.startDays = parseInt(this.getAttribute('data-start'), 10);
    this.endDays = parseInt(this.getAttribute('data-end'), 10);

    if (isNaN(this.startDays) || isNaN(this.endDays) || this.startDays < 0 || this.endDays < this.startDays) {
      console.error('Invalid delivery date range');
      return;
    }

    this.updateDeliveryDate();
  }

  updateDeliveryDate() {
    const finalDate = this.getDeliveryDates(this.startDays, this.endDays);
  }

  getDeliveryDates(deliveryMinDays, deliveryMaxDays) {
    let now = new Date();
    const deliveryMin = this.getDayExcludingWeekends(now, deliveryMinDays);
    const deliveryMax = this.getDayExcludingWeekends(now, deliveryMaxDays);

    return `${this.formateDate(deliveryMin, this.dateFormatOptions)} - ${this.formateDate(deliveryMax, this.dateFormatOptions)}`;
  }

  formateDate(date, options) {
    return date.toLocaleDateString('de-DE', options);
  }

  getDayExcludingWeekends(startDate, days) {
    if (days <= 0) return new Date(startDate.getTime());

    let date = new Date(startDate.getTime());
    let addedDays = 0;

    while (addedDays < days) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) {
        addedDays++;
      }
    }

    return date;
  }
}

customElements.define('delivery-widget', DeliveryWidget);
